const t = {
  styleOverrides: {
    root: ({ theme: e }) => ({
      color: e.palette.primary.light,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      },
      "&:visited": {
        color: e.palette.primary.main
      }
    })
  }
};
export {
  t as link
};
//# sourceMappingURL=link.mjs.map
